module.exports = __webpack_public_path__ + "img/studio de cinéma.51ee8926.png";